{
  "pageTitle": "Postavke",
  "discord": "Discord",
  "bank": "Banka (ASA)",
  "notifications": "Obavijesti",
  "channel": "Kanal",
  "payment": "Plaćanje",
  "configuredViaEnableDiscord": "Konfigurisano putem ENABLE_DISCORD",
  "configuredViaDiscordChannel": "Konfigurisano putem DISCORD_CHANNEL",
  "configuredViaPaymentEnabled": "Konfigurisano putem PAYMENT_ENABLED",
  "maskedValue": "••••••••",
  "bankNamePlaceholder": "Naziv banke (npr. ASA, Procredit)",
  "usernamePlaceholder": "Korisničko ime banke",
  "passwordPlaceholder": "Lozinka banke",
  "saving": "Čuvanje...",
  "create": "Kreiraj",
  "cancel": "Otkaži",
  "setDefault": "Postavi kao default",
  "delete": "Obriši",
  "onlyBankCannotDelete": "Jedina banka — ne može se obrisati",
  "edit": "Uredi",
  "bankNameInputPlaceholder": "Naziv banke",
  "update": "Ažuriraj",
  "usernameKeepPlaceholder": "Trenutno korisničko ime (ostavite prazno da zadržite)",
  "currentUsername": "Trenutno korisničko ime",
  "newPassword": "Nova lozinka",
  "leaveEmptyToKeep": "ostavite prazno da zadržite",
  "loading": "Učitavanje...",
  "addBank": "Dodaj banku",
  "noBanks": "Još nema konfigurisanih banaka",
  "noBanksHint": "Dodajte prvu banku da omogućite plaćanja.",
  "bankProviders": "Banke",
  "notificationsConfigured": "Obavijesti su konfigurisane",
  "channelConfigured": "Kanal je konfigurisan",
  "scrapingSchedule": "Raspored scraping-a",
  "scrapingLoading": "Učitavanje...",
  "scrapingSave": "Sačuvaj",
  "scrapingSaving": "Čuvanje...",
  "scrapingDisable": "Onemogući raspored",
  "scrapingLoadError": "Neuspjelo učitavanje rasporeda scraping-a",
  "scrapingUpdateError": "Neuspjelo ažuriranje rasporeda scraping-a",
  "scrapingDisableError": "Neuspjelo onemogućavanje rasporeda scraping-a",
  "scrapingScheduleDescription": "Automatski pokreće svakog dana u odabranom vremenu",
  "minInvoiceAmount": "Minimalni iznos računa",
  "minInvoiceAmountDescription": "Računi ispod ovog iznosa označavaju se kao preskočeni i ne plaćaju se. Ostavite prazno za onemogućavanje.",
  "minInvoiceAmountPlaceholder": "npr. 10,00",
  "scheduleActive": "Aktivno",
  "defaultBank": "Defaultna banka",
  "deleteConfirmPrompt": "Da li ste sigurni da želite obrisati ovu adresu?"
}
